import { HTTPError, TimeoutError } from "ky";
import { getApiErrorCode } from "@/lib/api-error";
import { smartCreationOwnerKey } from "@/lib/smart-creation-draft-store";

/** Who issued a durable Plan command, so late settlements for another Plan are ignored. */
export interface DurableActionIdentity {
  identity: string;
  planId: string;
  shopId: string;
}

export function smartCreationPlanQueryKey(shopId: string, planId: string) {
  return ["smart-creation", "browser-draft", smartCreationOwnerKey(), shopId, planId] as const;
}

export function structureEvaluationQueryKey(shopId: string, planId: string, revision: number) {
  return ["smart-creation", "structure-evaluation", shopId, planId, revision] as const;
}

export function retryTransientPlanRead(failureCount: number, error: Error): boolean {
  if (failureCount >= 3) return false;
  if (error instanceof HTTPError) return [502, 503, 504].includes(error.response.status);
  return error instanceof TypeError || error instanceof TimeoutError;
}

export function transientPlanRetryDelay(attempt: number): number {
  return Math.min(300 * 2 ** attempt, 1_200);
}

export async function isRevisionConflict(error: unknown): Promise<boolean> {
  const code = await getApiErrorCode(error);
  return (
    code === "smart_creation.revision_conflict" ||
    code === "smart_creation.review_revision_conflict"
  );
}

export function claimSmartCreationActionLock(
  lock: { current: boolean },
  identity: string,
  mounted: boolean,
): string | null {
  // A stale action handler must not claim the lock when no mounted Plan can
  // receive its mutation settlement and release it.
  if (lock.current || !mounted || !identity) return null;
  lock.current = true;
  return identity;
}
